import React, { Component } from 'react'
import styled from 'styled-components'
import Transition from 'react-transition-group/Transition'

import responsive from '../utils/responsive'
import appleIcon from '../images/apple-icon.svg'

const Container = styled.a`
  font-family: 'Roboto Mono'; 
  font-size: ${responsive(16, 24, 320, 1280)};
  color: #000000;
  padding: ${responsive(15, 30, 320, 1280)};
  background-color: #FFFFFF;
  display: inline-flex;
  align-items: flex-end;
  text-decoration: none;
  transition: all .3s ease;
  border: none;
  cursor: pointer;
  transition: opacity .6s ease, transform .6s ease;
  opacity: 0;
  transform: translateY(20px);

  &:hover {
    transform: translateY(-5px) !important;
    background-color: #F2f2f2;
  }

  &:focus {
    outline: none;
  }
`

const Icon = styled.img`
  width: 30px;
  margin-right: 15px;
`

const Label = styled.div`
  line-height: 1;
`

const transitionStyles = {
  entered:  {
    opacity: 1,
    transform: 'translateY(0)'
  },
}

class Button extends Component {
  render () {
    return (
      <Transition in={this.props.loaded} timeout={this.props.timeout}>
      {(state) => (
        <Container
          href='https://drive.google.com/file/d/1trisrWt4VrY8e_n9sL637i-PvjJbboGP'
          target="_blank" rel="noopener noreferrer"
          style={{...transitionStyles[state]}}
          >
          <Icon src={appleIcon} />
          <Label>Get for Mac</Label>
        </Container>
      )}
      </Transition>
    )
  }
}

export default Button


// WEBPACK FOOTER //
// ./src/components/Button.jsx